import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getAdminAuthToken, getAdminData, validateAdminToken } from '../utils/adminAuth';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

export default function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      const token = getAdminAuthToken();
      const adminData = getAdminData();

      if (!token || !adminData) {
        setIsAuthenticated(false);
        return;
      }

      // Validate token with server
      const isValid = await validateAdminToken();
      setIsAuthenticated(isValid);
    };

    checkAuth();
  }, []);

  // Show loading state while checking authentication
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-[radial-gradient(circle_at_top,#1c2135_0,#05060a_55%,#020308_100%)] flex items-center justify-center">
        <div className="text-[#9ca4c0]">Verificando autenticação...</div>
      </div>
    );
  }

  // Not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Authenticated, render the protected content
  return <>{children}</>;
}
